

































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import Employee from '../../apiClient/Employee'

@Component({
  name: 'Zoom',
})
export default class Zoom extends Vue {
  @Prop() imgValue: string
  @Prop({ default: 'png' }) fileExtension: string
  imgToShow: any
  base64: any
  totalsPages: number
  curPage: number
  reRenderKey: number
  rotation: number
  pdfLoaded: boolean
  ob: Employee
  @Watch('imgValue')
  onPropertyChanged(value: string) {
    this.base64 = ''
    this.imgToShow = value
    this.ob = new Employee()
    if (this.imgToShow !== '') {
      this.ob
        .getPreviewFileForEmployee(this.$route.params.id, this.imgToShow)
        .then((res: any) => {
          if (res.status === 200) {
            this.base64 = res.data
            this.reRenderKey += 1
            this.curPage = 1
            this.totalsPages = 0
            this.pdfLoaded = false
          }
        })
        .catch(() => {})
    }
  }
  data() {
    return {
      imgToShow: '',
      base64: '',
      totalsPages: 0,
      curPage: 1,
      reRenderKey: 0,
      rotation: 0,
      pdfLoaded: false,
    }
  }
  normalizeRotation(doc) {
    this.pdfLoaded = true
    if (doc.page.pdfPageRotate > 0) {
      this.rotation = doc.page.pdfPageRotate * -1
    }
  }
  nextPage() {
    if (this.curPage < this.totalsPages) this.curPage++
  }
  prevPage() {
    if (this.curPage > 1) this.curPage--
  }
}
